import { useLayoutEffect } from 'react';

/**
 * Hook to lock body scrolling when modals are open.
 * Prevents underlying content from scrolling and flickering.
 * @param isLocked - Whether to lock the body scroll
 */
export const useBodyScrollLock = (isLocked: boolean) => {
  // The full-screen flows animate in and out around this lock. Apply and
  // restore it before paint so the map behind them never renders one frame in
  // the wrong body positioning state.
  useLayoutEffect(() => {
    if (!isLocked) return;

    // Save current scroll position
    const scrollY = window.scrollY;
    const body = document.body;

    // Lock body scroll by fixing position
    body.style.position = 'fixed';
    body.style.top = `-${scrollY}px`;
    body.style.width = '100%';
    body.style.overflow = 'hidden';

    // Cleanup function to restore scroll
    return () => {
      body.style.position = '';
      body.style.top = '';
      body.style.width = '';
      body.style.overflow = '';
      // Restore scroll position
      window.scrollTo(0, scrollY);
    };
  }, [isLocked]);
};
